export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// mode: no-cors is required for browser → Apps Script calls; response is opaque, fire-and-forget
export const subscribeEmail = async (email) => {
  await fetch(process.env.REACT_APP_SUBSCRIBE_URL, {
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    body: JSON.stringify({ email }),
    mode: "no-cors",
  });
};

export const TEXT_VN = {
  heading: "Đăng ký nhận bản tin",
  subText:
    "Hàng năm, chúng tôi có những bài viết về nguyên liệu, món ăn theo mùa của Việt Nam. Chúng tôi rất vui được gửi tới bạn.",
  placeholder: "Email nhận tin",
  submit: "Đăng ký",
  successHeading: "Cảm ơn bạn!",
  successSub:
    "Bạn đã đăng ký thành công. Chúng tôi sẽ gửi tin tức mới nhất đến bạn.",
};

export const TEXT_EN = {
  heading: "Subscribe to our Stories",
  subText:
    "Season after season, we craft soulful stories about local ingredients and the seasonal heritage of Vietnamese cuisine. We'd love to take you along on these journeys.",
  placeholder: "Your Email Address",
  submit: "Join our journey",
  successHeading: "Thanks for joining us!",
  successSub:
    "You're in! We can't wait to share the freshest journeys from our kitchen with you. See you in your mail soon.",
};

export const getEmailSubscribeText = (language) =>
  language === "en" ? TEXT_EN : TEXT_VN;
